import React from "react";
import { clsx } from "clsx";

interface ISectionProps extends React.PropsWithChildren {
  headline?: string;

  /**
   * @default true
   */
  primary?: boolean;

  /**
   * @default false
   */
  primaryContent?: boolean;
}

export default function Section(props: ISectionProps) {
  const { children, headline, primary = true, primaryContent } = props;

  return (
    <section
      className={clsx(
        "flex",
        "flex-col",
        "items-center",
        "lg:max-w-3xl",
        "max-w-xl",
        "md:max-w-2xl",
        "p-4",
        "space-y-6",
        "w-full",
      )}
    >
      {headline && (
        <h2
          className={clsx(
            "border-b-2",
            {
              "border-primary": primary,
              "border-primary-content": primaryContent,
            },
            "font-bold",
            "text-lg",
            {
              "text-primary-content": primaryContent,
            },
          )}
        >
          {headline}
        </h2>
      )}
      {children}
    </section>
  );
}
